import { getIBPPUserData } from './ibppIntegration'

const customRegistrationRoutes = [
  {
    name: 'sppt',
    path: '/sppt',
    meta: {
      fn (args = {}, $this) {
        $this.formData['incomingPartnerName'].value = 'sppt'
      }
    },
    hasLogo: true,
    image: 'sppt-logo.png'
  },
  {
    name: 'gioia',
    path: '/gioia',
    meta: {
      fn (args = {}, $this) {
        $this.formData['incomingPartnerName'].value = 'gioia'
      }
    },
    hasLogo: false
  },
  {
    name: 'ibpp',
    path: '/ibpp/:uuid?',
    meta: {
      fn: getIBPPUserData
    },
    hasLogo: true,
    image: 'ibpp-logo.png'
  }
]

export default customRegistrationRoutes
